import EntryLanguageFooter from "../../EntryLanguageFooter";
import { useEffect } from "react";
import DevPre from "../../dev/DevPre";
import "./styles/style.scss";
import { useUser } from "../../../hooks/useApi";
import Button from "../../basic/Button";
import { useNavigate } from "@reach/router";

import { T } from "../../../hooks/useLanguage";
import Loader from "../../basic/Loader";
import EmailLoginDiagnosticsPanel from "../../EmailLoginDiagnosticsPanel";
import {
  normalizeNotificationId,
  normalizeVerificationCode,
} from "../../../services/emailLoginDiagnostics";

import { getRadioEntryPath } from "../../../features/entryFlow/entryIntentStorage";

export default function EmailLogin() {
  // get code and id from GET params
  const urlParams = new URLSearchParams(window.location.search);
  const code = normalizeVerificationCode(urlParams.get("code") ?? "");
  const parameterId = normalizeNotificationId(urlParams.get("id") ?? "");
  const navigate = useNavigate();
  const missingParams = !code || !parameterId;

  const {
    mutation: loginMutation,
    confirmloginMutation,
    emailLoginCheckFailure,
    notificationid,
    setNotificationid,
  } = useUser();

  useEffect(() => {
    if (!missingParams && parameterId) {
      setNotificationid(parameterId);
    }
  }, [missingParams, parameterId, setNotificationid]);

  useEffect(() => {
    if (missingParams) return;
    if (!notificationid) return;
    if (notificationid !== parameterId) return;
    if (confirmloginMutation?.status === "idle") {
      confirmloginMutation.mutate(code);
    }
    // return () => confirmloginMutation.reset();
  }, [confirmloginMutation, code, missingParams, notificationid, parameterId]);

  useEffect(() => {
    return () => confirmloginMutation.reset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="email-login">
      {missingParams && (
        <>
          <h1>
            <T>emaillogin.errorTitle</T>
          </h1>
          <p>
            <T>emaillogin.missingparams</T>
          </p>
          <br />
          <Button onClick={() => navigate(getRadioEntryPath() || "/")} className="success">
            <T>emaillogin.loginagain</T>
          </Button>
        </>
      )}
      {confirmloginMutation.isLoading && (
        <>
          <h1>
            <T>emaillogin.loadingTitle</T>
          </h1>
          <p>
            <T>emaillogin.loadingSubtitle</T>
          </p>
          <Loader />
        </>
      )}
      {confirmloginMutation.isSuccess && !emailLoginCheckFailure && (
        <>
          <h1>
            <T>emaillogin.title</T>
          </h1>
          <p>
            <T>emaillogin.subtitle</T>
          </p>
          <br />
          <Loader />
        </>
      )}
      {emailLoginCheckFailure && (
        <>
          <h1>
            <T>emaillogin.errorTitle</T>
          </h1>
          <EmailLoginDiagnosticsPanel
            error={{
              message: emailLoginCheckFailure.message,
              response: {
                data: {
                  msg: emailLoginCheckFailure.message,
                  reason: "login_not_found",
                },
              },
            }}
            titleKey="verify.loginnotfoundtitle"
            hintKey="verify.loginnotfoundhint"
          />
          <br />
          <Button onClick={() => navigate(getRadioEntryPath() || "/")} className="success">
            <T>emaillogin.loginagain</T>
          </Button>
        </>
      )}
      {confirmloginMutation.isError && (
        <>
          <h1>
            <T>emaillogin.errorTitle</T>
          </h1>
          <p>
            <T>emaillogin.errorSubtitle</T>
          </p>
          <EmailLoginDiagnosticsPanel error={confirmloginMutation.error} />
          <br />
          <Button onClick={() => navigate(getRadioEntryPath() || "/")} className="success">
            <T>emaillogin.loginagain</T>
          </Button>
        </>
      )}
      <EntryLanguageFooter />
      <DevPre>{loginMutation.status}</DevPre>
    </div>
  );
}
